<template>
  <div class="ticket-container">
    <div class="mb20">
      <el-button type="primary" @click="handleAdd">新增</el-button>
    </div>
    <!-- 数据表格 -->
    <el-table
      :data="tableData"
      border
      style="width: 100%">
      <el-table-column type="index" align="center" label="序号 " width="120" />
      <el-table-column prop="name" align="center" label="账户名称" width="120" />
      <el-table-column align="center" label="操作" width="160">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.row)">编辑</el-button>
          <!-- 删除按钮暂时隐藏 -->
          <el-button
            size="mini"
            type="danger"
            @click="handleDelete(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 新增/编辑对话框 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="30%">
      <el-form :model="formData" label-width="80px">
         <el-form-item label="账户名称">
          <el-input v-model="formData.name" placeholder="请输入类型名称"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitForm">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import requestTicket from '@/utils/requestTicket'

export default {
  name: 'Ticket',
  data() {
    return {
      tableData: [],
      dialogVisible: false,
      dialogTitle: '新增',
      formData: {}
    }
  },
  mounted() {
    this.fetchData()
  },
  methods: {
    // 获取数据列表
    async fetchData() {
      try {
        const res = await requestTicket.post('/Ticketing/account/findAll')
        this.tableData = res.data
      } catch (error) {
        console.error('获取数据失败:', error)
      }
    },
    // 新增操作
    handleAdd() {
      this.formData = {}
      this.dialogTitle = '新增'
      this.dialogVisible = true
    },

    // 编辑操作
    handleEdit(row) {
      this.formData = { ...row }
      this.dialogTitle = '编辑'
      this.dialogVisible = true
    },

    // 提交表单
    async submitForm() {
      try {
        await requestTicket.post('/Ticketing/account/save', this.formData)
        this.$message.success('操作成功')
        this.dialogVisible = false
        this.fetchData()
      } catch (error) {
        console.error('操作失败:', error)
        this.$message.error('操作失败')
      }
    },

    // 删除操作（暂时隐藏）
    async handleDelete(id) {
      try {
        await requestTicket.delete(`/Ticketing/account/${id}`)
        this.$message.success('删除成功')
        this.fetchData()
      } catch (error) {
        console.error('删除失败:', error)
        this.$message.error('删除失败')
      }
    }
  }
}
</script>

<style scoped>
.ticket-container {
  padding: 20px;
}
.mb20 {
  margin-bottom: 20px;
}
</style>